<template>
  <div class="reporting-interface-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ReportingInterfaceWrapper"
}
</script>

<style scoped>
.reporting-interface-wrapper {
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
}
</style>
